export default "__VITE_ASSET__BX$kJaW4__"